export default "/images/1f2974379bca8463f29ef9eb1d9dbf40.avif";